import {makeStyles} from '@material-ui/styles';

export default makeStyles((theme) => ({
        'root': {
            width: '100%',
        },
        '__content': {
            padding: [0, '!important'],
            maxWidth: ['100%', '!important'],
            background: ['none', '!important'],
        },
        '__cta': theme.gutter.lg.margin.top,
    }),
    {
        name: 'ServiceWarrantyPage',
    },
);
